import CompanyEmployeeList from "@/views/Company/Employee/CompanyEmployeeList.vue";
const routes = [
    {
        path: "/company/employee/list/:company_uuid",
        name: "CompanyEmployeeList",
        component: CompanyEmployeeList,
    },
];
export default routes;
